import React from "react"
import { View } from "react-native"
import { IconImageM } from "../icons/IconsM"
import TextM from "../text/TextM"

export function StatisticsItemProfile(props) {
    // ** Component props
    const { color, source, uri, count, totalCount, style } = props

    return (
        <View
            style={{
                borderRadius: 16,
                marginRight: 10,
                marginVertical: 0,
                ...style,
            }}
        >
            {
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingHorizontal: 10,
                        paddingVertical: 2,
                    }}
                >
                    <IconImageM width={30} source={source} uri={uri} />
                    {count !== undefined && (
                        <TextM fontWeight="Bold" color={color} fontSize={16}>
                            {count}
                            {totalCount ? ` / ${totalCount}` : ""}
                        </TextM>
                    )}
                </View>
            }
        </View>
    )
}
